import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import WhyUsHero from './components/WhyUsHero';
import OurModelSection from './components/OurModelSection';
import DataAdvantageSection from './components/DataAdvantageSection';
import TrustSystemSection from './components/TrustSystemSection';
import ImpactSection from './components/ImpactSection';
import ComparisonTable from './components/ComparisonTable';
import WhyUsCTABand from './components/WhyUsCTABand';

export default function WhyUsPage() {
  return (
    <>
      <Navbar />
      <main>
        <WhyUsHero />
        <OurModelSection />
        <DataAdvantageSection />
        <TrustSystemSection />
        <ImpactSection />
        <ComparisonTable />
        <WhyUsCTABand />
      </main>
      <Footer />
    </>
  );
}